import React from 'react'
import sScrollList from './ScrollList.less'
import s from './ScrollListWithTitle.less'
import ScrollListWithTitlePlaceholder from './ScrollListWithTitlePlaceholder'
import ResponsiveScrollList from './ResponsiveScrollList'

const ScrollListWithTitle = ({ title, data, ...restProps }) => (
  <div>
    <div className={s.title}>{title}</div>
    {data ? (
      <ResponsiveScrollList
        {...{ data, ...restProps }}
        listClassName={sScrollList.list}
        listItemClassName={sScrollList.listItem}
        arrowClassName={sScrollList.arrow}
        arrowLeftClassName={sScrollList.arrowLeft}
        arrowRightClassName={sScrollList.arrowRight}
      />
    ) : (
      <ScrollListWithTitlePlaceholder />
    )}
  </div>
)

export default ScrollListWithTitle
